<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok" :loading="loading" @on-cancel="cancel" :width="610" >
      <h3 slot="header" class="modal-header">修改确认单</h3>
      <div>
        <Form :model="formData" :label-width="120"  ref="formData" :rules="formRules">
          <FormItem label="项目">
            <div>{{formData.projectName}}</div>
          </FormItem>
          <FormItem label="签约管家" prop="zoName" class="">
            <div>{{formData.zoName}}</div>
          </FormItem>
          <FormItem label="客户姓名" prop="customerName" class="">
            <Input v-model="formData.customerName" class="item-width" ></Input>
          </FormItem>
          <FormItem label="联系方式" prop="customerPhone" class="">
            <Input v-model="formData.customerPhone" class="item-width" ></Input>
          </FormItem>
          <FormItem label="合同号" prop="contractCode" class="">
            <Input v-model="formData.contractCode" class="item-width" ></Input>
          </FormItem>
          <FormItem label="房间号" prop="roomLabel"  >
            <Select
              class="item-width"
              v-model="formData.stockFid"
              filterable
              remote
              :remote-method="remoteMethod"
              :loading="remoteLoading"
              placeholder=""
              :label-in-value="true"
              :label="roomLabel"
              @on-change="getRoomCode"
            >
              <Option v-for="item in roomList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
          <FormItem label="月租金" prop="monthPrice" class="">
            <Input v-model="formData.monthPrice" class="item-width" :number="true" @on-change="calculationService(formData)"></Input>
          </FormItem>
          <FormItem label="总租金" prop="totalPrice" class="">
            <Input v-model="formData.totalPrice" class="item-width" :number="true" @on-change="calculationService(formData)"></Input>
          </FormItem>
          <FormItem label="平台服务费" prop="servicePrice" class="">
            <InputNumber v-model="formData.servicePrice" class="item-width" :number="true"></InputNumber>
          </FormItem>
          <FormItem label="合同起止日"  prop="dateList" class="item-width">
            <DatePicker  v-model="formData.dateList" class="select-long2" type="daterange" style="width:280px"
                        placement="bottom-end"  split-panels
                        placeholder="" ></DatePicker>
          </FormItem>
          <FormItem label="签约日期" prop="conSignDate">
            <DatePicker  type="date" placeholder="" style="width:280px"
                        v-model="formData.conSignDate"></DatePicker>
          </FormItem>
          <FormItem label="合同照片" prop="contractPic" class="">
            <div style="display: flex;flex-wrap: wrap">
              <template v-for="item in pics " v-if="pics">
                <div class="fileItem">
                  <div style="margin-bottom: 10px;">
                    <img class="file-img" :src="item.url" alt="" @click="showImg(item.url)">
                    <a href="javascript:;" style="vertical-align: bottom" @click="deleteItem(item)">删除</a>
                  </div>
                </div>
              </template>
              <div class="fileItem" v-if="!pics || pics.length<=3">
                <Upload class="upload"
                        :action="baseUrl+'/file/uploadFile'"
                        :on-success="handleSuccess"
                        :headers="{'Access-Token':token}"
                        :show-upload-list="false"
                        :on-error="handleError"
                        :format="['jpg','jpeg','png']"
                        :on-format-error="formatError"
                >
                  <Icon type="ios-plus-empty" size="80" style="vertical-align: middle"></Icon>
                </Upload>

              </div>
            </div>
          </FormItem>
        </Form>
      </div>
    </Modal>
    <img-show :src="imgSrc" :n="showImgKey"></img-show>
  </div>
</template>
<script>
  import {formatDateTime} from "../../../utils/format";
  import {saveOrUpdate,findOrderListById} from "../../../api/confirmOrder";
  import { fuzzyRoom } from '../../../api/functionalArea';
  import {getBaseUrl} from "@/utils/public";
  import {getToken} from "@/utils/auth";
  import ImgShow from 'components/ImgShow/index';

  export default {
    name: "ModifyConfirmOrderForm"   ,
    components:{
      ImgShow
    },
    created() {
    },
    props:{
      n:{
        type:Number,
        default:0
      },
      confirmOrderFid:{
        type:String,
        default:''
      },
      businessFid:{
        type:String,
        default:''
      },
      serviceRate:{
        type:Number,
        default:0
      }


    },
    watch:{
      n(val){
        this.pics = []
        this.addPics = []
        this.removePics = []
        this.$refs['formData'].resetFields();
        this.isShow = true;
        this.findConfirmOrderInfo();
        this.baseUrl = getBaseUrl();
        this.token = getToken();
      },
    },
    data(){
      return {
        loading: true,
        isShow:false,
        showImgKey:0,
        pics:[],
        addPics:[],
        roomList:[],
        remoteLoading:false,
        removePics:[],
        dateList:[],
        baseUrl:"",
        imgSrc:"",
        token:"",
        roomLabel:'',
        formData:{
            "projectFid":"",
            "projectName":"",
          "businessFid":"",
          "customerName":"",
          "customerPhone":"",
          "contractCode":"",
          "stockNum":"",
          "stockFid":"",
          "totalPrice":0,
          "conStartDate":"",
          "conEndDate":"",
          "conSignDate":"",
          "zoName":"",
          "zoFid":"",
          "contractPic":[],
          "dateList":[],
          "servicePrice":null,
          "monthPrice":0
        },
        formRules:{
          customerName:[ { required:true, message:'请输入客户姓名', trigger:'blur' } ],
          customerPhone:[ { required:true, message:'请输入客户手机', trigger:'blur' } ],
          contractCode:[ { required:true, message:'请输入合同号', trigger:'blur' } ],
          stockNum:[ {required: true,message:'请输入房间/床位号',trigger:'blur'} ],
          monthPrice:[ { required:true, message:'请输入正确的月租金额', type:'number', trigger:'blur' } ],
          totalPrice:[ { required:true, message:'请输入正确的合同总金额', type:'number', trigger:'blur' } ],
          servicePrice:[ { required:true, message:'请输入正确的平台服务费', type:'number', trigger:'blur' } ],
          dateList: [
            {required: true, trigger: 'change', message: '选择起租、到期时间', validator: this.validateDate}
          ],
        }
      }
    },
    methods:{
      clearData(){
        this.formData={
          "projectFid":"",
          "projectName":"",
          "businessFid":"",
          "customerName":"",
          "customerPhone":"",
          "contractCode":"",
          "stockNum":"",
          "stockFid":"",
          "totalPrice":"",
          "conStartDate":"",
          "conEndDate":"",
          "conSignDate":"",
          "zoName":"",
          "zoFid":"",
          "fid":"",
          "monthPrice":"",
          "servicePrice":null
        }

        this.$refs['formData']  && this.$refs['formData'].resetFields()


      },
      validateDate(rule, value, callback) {
        if (!value[0] || !value[1]) {
          callback(new Error('请选择日期'));
        }
        callback();
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      format(data) {
        if (!data) {
          return ''
        }
        return formatDateTime(data, false)
      },
      ok(){
        this.$refs['formData'].validate(bool => {
          if (bool) {

            this.formData.addPics=this.addPics;
            this.formData.removePics = this.removePics;
            this.formData.conStartDate=this.format(this.formData.dateList[0])
            this.formData.conEndDate=this.format(this.formData.dateList[1])
            saveOrUpdate(this.formData).then(res => {
              this.$Message.success('操作成功')
              this.$emit('refresh')
            }).catch(error=>{})
            this.isShow=false
          }
          else {
            this.changeLoading()
          }
        })

      },
      cancel(){

      },
      findConfirmOrderInfo(){
        findOrderListById(this.confirmOrderFid,this.businessFid).then(res => {
          this.formData=res.data;
          this.formData.dateList=[res.data.conStartDate,res.data.conEndDate];
          this.pics = res.data.pics;
          this.roomLabel = res.data.stockNum;
          this.serviceRate = res.data.serviceRate;
        }).catch(error=>{})
      },
      remoteMethod(query){
        if (query !== '' && this.formData.projectFid !=='') {
          this.remoteLoading = true;
          let params = {
            projectid:this.formData.projectFid,
            roomnumber:query
          }
          fuzzyRoom(params).then( res => {
            this.remoteLoading = false;
            this.roomList = res.data;
          })
        } else {
          this.roomList = [];
          this.formData.stockFid = ''
        }
      },
      getRoomCode(room){
        if(room.value){
          this.formData.stockFid = room.value
          this.formData.stockNum = room.label
        } else {
          this.formData.stockFid = ''
          this.formData.stockNum = ''
        }
      },
      formatError(){
        this.$Message.info('请上传图片类型文件')
      },
      handleSuccess(res) {
        this.addPics.push(res.data)
        this.pics.push(res.data)
      },
      handleError() {

      },
      deleteItem(img) {
        this.removePics.push(img)
        this.pics = this.pics.filter( item => {
          return item.fid != img.fid
        })
      },
      showImg(data) {
        this.imgSrc = data
        this.showImgKey++
      },
      calculationService(formData) {
        if(formData.totalPrice && formData.monthPrice) {
          formData.servicePrice = +((Number(formData.totalPrice) /Number(360) * Number(30) * Number(this.serviceRate)).toFixed(2));
        }
      }
    }

  }
</script>

<style scoped>
  .item-width{
    width: 280px;
  }
  .upload {
    display: inline-block;
    width: 150px;
    height: 85px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    line-height: 80px;
  }


</style>
